import { render, staticRenderFns } from "./UrlRedirect.vue?vue&type=template&id=26df39fa"
import script from "./UrlRedirect.vue?vue&type=script&lang=js"
export * from "./UrlRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports